import React from 'react';
import {getTopFrequentCategories} from '../../utils/functions';
import {Stack,Typography} from '@lapilli-ui/components';
import CategoryResult from './category-result';

const CategoryResults = ({label,query, categories, results, maxResults}) => {
    const listCategory = () => {
        let groups = [];
        if (results) {
            results.forEach(item => {
                if (item.parent_category.length > 0) {
                    groups = groups.concat(item.parent_category);
                }
            });
            return groups;
        }
    };

    const findCategory = (cats, categoryID) => {
        let currentCat = false;
        cats.forEach( c => {
            if( ! currentCat ){
                if (c.term_id === categoryID) {
                    currentCat = c;
                }else{
                    if (Array.isArray(c.children)) {
                        currentCat = findCategory(c.children, categoryID);
                    }
                }
            }
        });

        return currentCat;
    };

    const groupsOfCategories = () => {
        let groups = listCategory();

        if (groups.length > 0) {
            const topCategories = getTopFrequentCategories(groups,maxResults);
            return (
                <Stack className="search-category-results" sx={{
                    '& .ywcas-category-result:last-child': {
                        paddingBottom: 0
                    }
                }}>
                    {label &&  <Typography sx={{
                        '&': {
                            borderBottom: '1px solid #9797972e',
                            marginBottom:'17px'
                        }
                    }}>
                        {label}
                    </Typography>}
                    {topCategories.map(singleCategory => {
                        const currentCategory = findCategory(categories, singleCategory);
                        if (currentCategory) {
                            return <CategoryResult key={currentCategory.term_id} query={query} singleCategory={currentCategory}/>;
                        }
                    })
                    }
                </Stack>);
        }
    };

    return (
        <Stack>{groupsOfCategories()}</Stack>
    );

};

export default CategoryResults;